import * as React from 'react'
import {confirmAlert} from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css';

interface dd{
  title:string,
  message:string,
}

 
export const ConfirmTemplate = (data:dd,request:Function) => (
    confirmAlert({
        customUI: ({ onClose }) => {
            return (
              <div className='custom-ui'>
                <h1>{data.title}</h1>
                <p>{data.message}</p>
                <button onClick={onClose}>No</button>
                <button
                  onClick={() => {
                    request();
                    onClose();
                  }}
                >
                  Yes
                </button>
              </div>
            );
          }
      })
  )

